import React from "react";
import { Link } from "react-router-dom";
import { formatISTDate } from "../lib/results";

/**
 * The hero block. `h1` is a real, visible <h1> on every route — the old build
 * kept its keyword headings in an off-screen `.seo-hidden` block, which Google
 * treats as hidden text, so the copy now lives where users can read it.
 */
const PageHeader = ({ h1, intro, nowIST, showClock = false }) => (
  <header className="header-card">
    <Link to="/" className="header-logo-link" aria-label="Bagad Satta Company home">
      <img
        src="/bsc.png"
        alt="Bagad Satta Company logo"
        className="header-logo"
        width="90"
        height="90"
      />
    </Link>

    <h1 className="header-title">{h1}</h1>

    {intro && <p className="header-intro">{intro}</p>}

    {showClock && nowIST && (
      <p className="header-sub">
        Live Result — {formatISTDate(nowIST)}
        <span className="live-time">
          {" "}
          {nowIST.toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })}{" "}
          IST
        </span>
      </p>
    )}
  </header>
);

export default PageHeader;
